// Read-only viewer for a Meeting, rendered as a modal. Primary use is
// the archived-item deep-link flow. In-page view is MeetingDetailExpand.

import Modal from "../../../common/Modal";
import Button from "../../../common/Button";
import MeetingDetailExpand from "./MeetingDetailExpand";
import type { Meeting } from "../../../../types";

interface MeetingDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  item: Meeting | null;
  onMarkHeld?: () => void;
  onAddMinutes?: () => void;
}

export default function MeetingDetailModal({
  isOpen,
  onClose,
  item,
  onMarkHeld,
  onAddMinutes,
}: MeetingDetailModalProps) {
  if (!item) return null;
  const isArchived = !!item.archivedAt;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={isArchived ? "Meeting (archived)" : "Meeting"}
      maxWidth="sm:max-w-2xl"
    >
      <div className="space-y-4">
        <MeetingDetailExpand
          item={item}
          onMarkHeld={onMarkHeld}
          onAddMinutes={onAddMinutes}
        />

        <div className="flex justify-end gap-3 pt-2">
          {isArchived && (
            <Button
              variant="secondary"
              disabled
              title="Unarchive to edit — coming soon (self-service)"
              aria-label="Unarchive to edit — coming soon (self-service)"
            >
              Unarchive to edit
            </Button>
          )}
          <Button variant="primary" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
}
